import React from 'react'

import { Tabs } from 'antd'
import styled from 'styled-components'
import { RNumberView } from '@/modules/landings/protection/components/RNumberView'
import { ProtectDescriptionView } from '@/modules/landings/protection/components/ProtectDescriptionView'

const onChange = (key: string) => {
	console.log(key)
}

const RAuthTabWrapper = styled.div`
	position: relative;
	z-index: 9;

	.ant-tabs {
		display: block;
		background-color: #ff4c11;

		.ant-tabs-nav {
			max-width: 996px;
			height: 72px;
			margin: 0 auto;

			@media (max-width: 1200px) {
				height: 64px;
			}
			@media (max-width: 768px) {
				height: 56px;

				& > * {
					display: none;

					&.ant-tabs-nav-wrap {
						display: block;
					}
				}
			}

			.ant-tabs-nav-wrap {
				.ant-tabs-nav-list {
					position: relative;
					display: flex;
					width: 100%;

					.ant-tabs-tab {
						flex: 1;
						text-align: center;
						padding: 0;

						.ant-tabs-tab-btn {
							width: 100%;
							height: 100%;
							font-size: 24px;
							font-weight: normal;
							color: rgba(255, 255, 255, 0.7);
							line-height: 70px;
							padding: 0 30px;

							&[aria-selected='false']:hover {
								opacity: 0.7;
							}
						}

						&.ant-tabs-tab-active {
							.ant-tabs-tab-btn {
								font-weight: bold;
								color: #fff;
							}
						}

						@media (max-width: 1200px) {
							margin-left: 0;

							.ant-tabs-tab-btn {
								font-size: 20px;
								line-height: 56px;
							}
						}
						@media (max-width: 768px) {
							.ant-tabs-tab-btn {
								font-size: 16px;
							}
						}
					}

					.ant-tabs-ink-bar {
						position: absolute;
						bottom: 0;
						display: inline-block;
						width: 14px !important;
						height: 14px;
						margin-left: 25%;
						transform: translate(-50%, 50%) rotate(135deg);
						background-color: #fff;
					}
				}
			}
		}

		.ant-tabs-content-holder {
			.ant-tabs-content {
				.ant-tabs-tabpane {
				}
			}
		}
	}
`
const Wrapper = styled.div`
	background-color: #fdfdff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-bottom: 76px;
`

interface ProtectTabProps {}

export const ProtectTab: React.FC<ProtectTabProps> = (props) => {
	return (
		<RAuthTabWrapper>
			<Tabs defaultActiveKey="1">
				<Tabs.TabPane tab="R인증이란?" key="1">
					<ProtectDescriptionView />
				</Tabs.TabPane>
				<Tabs.TabPane tab="R인증 번호 조회" key="2">
					<Wrapper>
						<RNumberView />
					</Wrapper>
				</Tabs.TabPane>
			</Tabs>
		</RAuthTabWrapper>
	)
}
